import React, { useState, useEffect } from "react";
import { PrintRecord } from "../../../BlakeData/Types";
// import SingleImagePreviewWithEqualizedPalette as SingleImagePreview from "./SingleImagePreviewWithEqualizedPalette";
import SingleImagePreview from "./SingleImagePreview"
import ReactCompareImage from 'react-compare-image';
import { API } from "../../../BlakeData";

import Measure, { ContentRect } from 'react-measure';

import { getMaxWidth } from "./DivScale";
// import DetailedMetadata from "./DetailedMetadata";

interface Dimensions {
    width: number,
    height: number
}
/**
 * An image display that shows 1 image by itself, 2 images 
 * as a head-to-head comparison, or nothing. If more than
 * 2 images are passed, only the first two are used
 * @param props 
 */
export default function FullImage(props: {
    setImageWidth: (width: number) => void;
    width: number;
    height: number;
    prints: Array<PrintRecord>;
    enableComparison: boolean;
    quantizeMode: boolean;
}) {
    let preview: JSX.Element;

    const [dimensions, setDimensions] = useState<Dimensions>({ width: 0, height: 0 });
    const [imageDimensions, setImageDimensions] = useState<{ [url: string]: Dimensions }>({});

    const getURL = (p: PrintRecord) => props.quantizeMode ? API.getQuantizedImageURL(p) : API.getImageURL100(p);

    useEffect(
        () => {
            props.prints.forEach(p => {

                // preload the images so that we can get their dimensions
                const img = new Image();
                const url = getURL(p);


                img.src = url;

                img.onload = (event) => {
                    const img = event.target as HTMLImageElement;

                    if (imageDimensions.hasOwnProperty(url)) { return }
                    let newImageDimensions = Object.assign({}, imageDimensions);

                    newImageDimensions[url] = {
                        width: img.naturalWidth,
                        height: img.naturalHeight
                    }

                    setImageDimensions(newImageDimensions)
                }
            }, [])
        }
    )


    if (props.prints.length < 1) {
        return (null);
    }


    if (props.enableComparison && props.prints.length >= 2) {
        preview = <div>
            <ReactCompareImage
                leftImage={getURL(props.prints[0])}
                rightImage={getURL(props.prints[1])}
            />
        </div>

    } else if (props.prints.length > 0) {
        preview = <SingleImagePreview
            imageURL={getURL(props.prints[props.prints.length - 1])}
            print={props.prints[props.prints.length - 1]} />;
    }

    const getImageDimensions = (url: string): { width: number, height: number } | false => {
        if (!imageDimensions.hasOwnProperty(url)) { return false; }
        return imageDimensions[url];
    }

    const getCurrentMaxWidth = (): number => {
        return getMaxWidth(
            props.prints
                .map(p => getURL(p))
                .map(url => getImageDimensions(url)),
            { width: props.width, height: props.height })

    }

    const maxWidth = getCurrentMaxWidth();
    props.setImageWidth(maxWidth);


    return (
        <Measure
            bounds
            onResize={(contentRect: ContentRect) => {
                let { width, height } = contentRect.bounds || { width: -1, height: -1 };
                if (width < dimensions.width || height < dimensions.height) { return; }

                setDimensions({
                    width,
                    height
                });

            }}
        >

            {({ measureRef }) => {

                // fit the image with a given aspect ratio
                // into the space available

                return (
                    <div>
                        {/* <div><DetailedMetadata prints={props.prints.slice(0, 1)}></DetailedMetadata></div>
                        <div><DetailedMetadata prints={props.prints.slice(1,2)}></DetailedMetadata></div> */}

                        <div ref={measureRef}
                            style={{
                                maxWidth: maxWidth
                            }}
                            className={`FullImage ${props.quantizeMode ? "quantize" : ""}`}>
                            {preview}
                        </div>

                    </div>
                );
            }
            }
        </Measure>);
}